<template>
  <Panel
    :class="classes"
    :header="header"
    data-sb-regression="sb-panel"
  >
    <div
      v-if="showIcon"
      class="icon-wrapper"
      :class="[$style.iconWrapper, $style[`iconWrapper--${iconOrientation}`]]"
    >
      <i
        aria-hidden="true"
        :class="icon"
      />
    </div>
    <!--
          @slot slot to show contents of the panel
        -->
    <slot />
  </Panel>
</template>

<script setup>
import Panel from 'primevue/panel';
import { computed, defineProps, defineOptions, useCssModule } from 'vue';

defineOptions({
  name: 'SbPanelNext',
});

const $style = useCssModule();

const props = defineProps({
  /**
   * The version of the component. Defaults to current.
   * `current, next`
   */
  version: {
    type: String,
    default: 'current',
    validator: (value) => {
      return value.match(/(current|next)/);
    },
  },
  /**
   * Style variation for the panel.
   * This determines things like padding, and background color.
   * `default|sub|warning|bare`
   */
  variation: {
    type: String,
    default: 'default',
    validator: (value) => value.match(/(default|sub|warning|danger|info|success|bare)/),
  },
  /**
   * Orientation of the icon relative to the content
   * `default|sub|warning|bare`
   */
  iconOrientation: {
    type: String,
    default: 'center|start|end',
    validator: (value) => value.match(/(center|start|end)/),
  },
  /**
   * Header label to show at the top
   * `default:''`
   */
  header: {
    type: String,
    default: '',
  },
});

const showIcon = computed(() => {
  return props.variation.match(/(warning|danger|info|success)/);
});
const classes = computed(() => {
  // eslint-disable-next-line css-modules/no-undef-class
  return [$style.sbPanel, $style[`sbPanel-${props.variation}`], !props.header && $style.emptyHeader, !showIcon.value && $style.column].filter(Boolean);
});
const icon = computed(() => {
  const iconMap = {
    info: 'sb-icon-info',
    success: 'sb-icon-checkmark-outline',
    warning: 'sb-icon-alert-circle',
    danger: 'sb-icon-alert-triangle',
  };
  return iconMap[props.variation];
});
</script>

<style lang="scss" module>
@use '@src/components/Panel/style/sb-panel.module.scss';
</style>
